// Modules
import { useContext } from 'react';

// Components
import { Context } from '@/components/Store';
import { ActionTypes } from '@/components/Store.d';

type DropdownListItemProps = React.HTMLAttributes<HTMLOptionElement> & {
  children?: string;
};

const DropdownListItem = (props: DropdownListItemProps) => {
  const [, dispatch] = useContext(Context);

  const removeDropdowns = () => {
    dispatch({
      type: ActionTypes.resetCompletions,
      payload: {
        key: 'autocompletions',
        value: {
          zipCodes: [],
          cities: [],
          streets: []
        }
      }
    });
  };

  return (
    <option
      {...props}
      onChange={(event) => {
        const target = event.target as HTMLOptionElement;
        if (target.dataset.type === 'streets') {
          dispatch({
            type: ActionTypes.addressChange,
            payload: {
              key: 'address.delivery.street',
              value: target.dataset.street
            }
          });

          dispatch({
            type: ActionTypes.setStreetId,
            payload: {
              key: 'address.delivery.streetID',
              value: target.dataset.streetId
            }
          });
        } else {
          dispatch({
            type: ActionTypes.zipCity,
            payload: {
              zip: target.dataset.zip,
              city: target.dataset.city
            }
          });
        }

        removeDropdowns();
      }}
    >
      {props.children}
    </option>
  );
};

export { DropdownListItem };
